import React from 'react'
import './Socials.css'

export const Socials = () => {
    const socials =  [{href:"https://www.instagram.com/durgeshm01722/", class:"instagram"}, 
    {href:"https://www.linkedin.com/in/durgesh-mahajan-99bab0212/", class:"linkedin"},
    {href:"https://github.com/durgeshm01722", class:"github"}]
  
    return (
        <>
    {socials.map(item => {
        return <a href={item.href} className={`fa fa-${item.class}`} target="new" key={item.href}/>
    })}
    </>
  )
}